module.exports = __webpack_public_path__ + "stylesheets/notifications_eb97759b761a6ad35f8cad6bb4c0752f.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/notifications.less
// module id = x+OW
// module chunks = 55